var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[((!_vm.isENG)&&(_vm.headvalid))?_c('Header'):_vm._e(),_vm._v(" "),(_vm.isENG&&_vm.headvalid)?_c('Headereng'):_vm._e(),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath}),_vm._v(" "),(( !_vm.isENG)&&(_vm.footvalid))?_c('Footer'):_vm._e(),_vm._v(" "),(_vm.isENG&&_vm.footvalid)?_c('Footereng'):_vm._e(),_vm._v(" "),_c('GoTop')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-106bdcd3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 